
export const crypto = globalThis.crypto ?? (require("crypto").webcrypto as Crypto);
